import axios, { AxiosResponse } from "axios";
import { Common } from "../../../common/src/index";
import { config } from "../../config/config";

export default class PointUtil {
  /**
   * Grid点群データ削除
   * */
  static pointRowDel = async (selRows: any, projectId: string) => {
    try {
      if (selRows.length === 0) return;

      const deleteItemIds: string[] = [];
      selRows.forEach((v: string) => deleteItemIds.push(v));

      const body: Common.PointCoordinateDeleteInput = {
        ids: deleteItemIds,
      };

      const deleted = await axios
        .delete(
          `${config.serverHost}/api/v1/project/${projectId}/points/coordinate`,
          { data: body, withCredentials: true }
        )
        .then((res: AxiosResponse) => {
          return true;
        })
        .catch(() => {
          return false;
        });
      return deleted;
    } catch (e) {
      console.error(e);
      return false;
    }
  };

  /**
   * ボタンの活性・非活性
   * */
  static selChecked = (selRowLength: number) => {
    if (selRowLength > 0) return false;
    else return true;
  };

  /**
   * 座標入力タブ変更
   * */
  static updateRecord = async (
    itemId: string,
    itemName: string,
    itemVal: any,
    projectId: string
  ): Promise<void> => {
    try {
      const id: string | undefined = itemId;
      const field: string | undefined = itemName;
      const valueItem: any | undefined = itemVal;

      // Null Undefined Nan チェック
      if (!itemId || !field || !itemVal) return;
      let updateData: Common.PointCoordinateForUpdate | undefined = undefined;
      if (field === "x" || field === "y" || field === "z") {
        const numberValue = Number(valueItem);
        updateData = { id: id } as Common.PointCoordinateForUpdate;
        updateData[field] = numberValue;
      } else {
        updateData = { id: id } as Common.PointCoordinateForUpdate;
        updateData["name"] = valueItem;
      }
      await axios
        .put(
          `${config.serverHost}/api/v1/project/${projectId}/points/coordinate`,
          updateData,
          { withCredentials: true }
        )
        .then((res: AxiosResponse) => {})
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  };

  /**
   * 座標変換タブ変更
   * */
  static updateReference = async (
    itemId: string,
    itemName: string,
    itemVal: any,
    projectId: string,
    rowsHelmert: any[]
  ): Promise<void> => {
    try {
      const id: string | undefined = itemId;
      const fieldName: string | undefined = itemName;
      const valueItem: any | undefined = itemVal;

      if (!id || !fieldName || !valueItem) return;

      let updateData: Common.PointReferenceForUpdate | undefined = undefined;

      updateData = { id: id } as Common.PointReferenceForUpdate;
      (updateData as any)[fieldName] = valueItem;

      if (!updateData) return;

      await axios
        .put(
          `${config.serverHost}/api/v1/project/${projectId}/points/reference`,
          updateData,
          { withCredentials: true }
        )
        .then((res: AxiosResponse<Common.PointReference>) => {
          const data = res.data;
          const row_data = rowsHelmert.find((r) => r.id === data.id);
          if (row_data) {
            row_data.correspondingPointId = data.correspondingPointId;
            row_data.x = data.x;
            row_data.y = data.y;
            row_data.z = data.z;
            row_data.dx = data.dx;
            row_data.dy = data.dy;
            row_data.dz = data.dz;
            row_data.originalPoint = data.name;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (e) {
      console.error(e);
    }
  };

  /**
   * 検証点精度確認タブ変更
   * */
  static PointVerificationUpdate = async (
    itemId: string,
    itemName: string,
    itemVal: any,
    projectId: string,
    rowsVerification: any[]
  ): Promise<void> => {
    try {
      const id: string | undefined = itemId;
      const fieldName: string | undefined = itemName;
      const valueItem: any | undefined = itemVal;

      if (!id || !fieldName || !valueItem) return;

      let updateData: Common.PointVerificationForUpdate | undefined = undefined;
      updateData = { id: id } as Common.PointReferenceForUpdate;
      (updateData as any)[fieldName] = valueItem;
      if (!updateData) return;

      await axios
        .put(
          `${config.serverHost}/api/v1/project/${projectId}/points/verification`,
          updateData,
          { withCredentials: true }
        )
        .then((res: AxiosResponse<Common.PointVerification>) => {
          const data = res.data;
          const row_data = rowsVerification.find((r) => r.id === data.id);
          if (row_data) {
            row_data.correspondingPointId = data.correspondingPointId;
            row_data.x = data.x;
            row_data.y = data.y;
            row_data.z = data.z;
            row_data.dx = data.dx;
            row_data.dy = data.dy;
            row_data.dz = data.dz;
            row_data.realPoint = data.name;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (e) {
      console.error(e);
    }
  };
}
